<h2 mat-dialog-title>Send to Blender</h2>
<mat-dialog-content>
    <form id="sendToBlenderForm" class="cm-send-to-blender-form" (ngSubmit)="confirmAction()">
        <div>{{ counts.length ? counts.join(", ") : "Nothing that Blender can show" }}</div>
        @if (data.meshCount > 0) {
            <mat-checkbox [(ngModel)]="$includeMaterials" name="includeMaterials">Include materials</mat-checkbox>
        }
        @if (data.cameraCount > 0 || data.renderCount > 0) {
            <div>Blender lists the render settings that would change and asks before changing them</div>
        }
        @if (data.renderCount > 1) {
            <div>Blender gets the settings of the first of the {{ data.renderCount }} Render nodes</div>
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="cm-dialog-actions">
    <button mat-button type="submit" form="sendToBlenderForm" [disabled]="counts.length === 0" autofocus>Send</button>
    <button mat-button (click)="cancelAction()">Cancel</button>
</mat-dialog-actions>
